<template>
  <footer class="footer">
    <div class="footer-content">
      <p>&copy; 2025 Your Company. All rights reserved.</p>
      <ul class="footer-links">
        <li><a href="#">이용약관</a></li>
        <li><a href="#">개인정보처리방침</a></li>
        <li><a href="#">문의하기</a></li>
      </ul>
    </div>
  </footer>
</template>
<style scoped src="@/assets/style/mainpage.css"></style>